import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18b1c0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "header" }, "C2Ops Classes", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Class Code")
  ])
], -1))
const _hoisted_3 = ["onClick"]

import { PropType } from 'vue';
import { Class } from '@/models/Class';
import { formatDate_DD_MMM_YYYY_NO_DOT } from '@/utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassListTable',
  props: {
  classes: {
    type: Array as PropType<Class[]>,
    required: true
  },
  selected: {
    type: Object as PropType<Class | null>
  }
},
  emits: ['select-class'],
  setup(__props, { emit }) {





const handleSelectClass = (courseClass: Class) => {
  emit('select-class', courseClass);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("table", null, [
      _hoisted_2,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.classes, (courseClass) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: courseClass.id,
            class: _normalizeClass({
            active: __props.selected?.id === courseClass.id
          }),
            onClick: ($event: any) => (handleSelectClass(courseClass))
          }, [
            _createElementVNode("td", null, _toDisplayString(courseClass.name), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatDate_DD_MMM_YYYY_NO_DOT)(new Date(courseClass.startDate))), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(formatDate_DD_MMM_YYYY_NO_DOT)(new Date(courseClass.endDate))), 1),
            _createElementVNode("td", null, _toDisplayString(courseClass.inviteCode), 1)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ])
  ]))
}
}

})